exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1,h2{font-weight:400;margin:16px 0}p{line-height:32px}.gift_sent_root{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.gift_sent_description{margin-bottom:16px}.gift_sent_description svg{width:84px}.send_by_container{margin-bottom:64px}.send_email,.share_receiver_account{margin-bottom:72px}.cancel_gift{margin-bottom:16px}.share_link{color:#9b9b9b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7a90d893","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GiftSent.vue
// module id = 73
// module chunks = 0